<!-- <div>
  <div class="bookings-wrapper form-control">
    <div class="form-label">Booking Id</div>
    <div class="booking-list">
      <div class="booking-id" (click)="onBookingClick(booking)" *ngFor="let booking of bookings">{{booking.bookingId}}</div>
    </div>
  </div>
  <div class="form-container" *ngIf="!loading">
    <ng-container *ngFor="let field of config.elementConfigList">
      <div class="form-control half-width" *ngIf="checkVisibility(field.config, formDetails)">
        <div class="form-label">{{field.config.displayName}}</div>
        <span class="optional" *ngIf="!field.config.mandatory">(optional)</span>
        <div class="form-input">
          <app-select-sectioned
            *ngIf="field.config.elementType == 'dropdown'"
            [formControl]="formDetails.get(field.elementKey)"
            type="dropdown"
            [getCustomOptionValue]="getOptionValue"
            [getCustomOptionLabel]="getOptionLabel"
            [options]="options[field.elementKey]">
          </app-select-sectioned>
          <app-field-generator
            *ngIf="field.config.elementType != 'dropdown' && field.elementKey!='guardReq'"
            [config]="field.config"
            [inputControl]="formDetails.get(field.elementKey)">
          </app-field-generator>
          <app-toggle-button
          *ngIf="field.elementKey=='guardReq'"      
              [formControl]="formDetails.get(field.elementKey)"
          [isDisabled]="false"
          >
          </app-toggle-button>
        </div>
      </div>
    </ng-container>
  </div>
</div>-->


<div class="container">
  <div class="fs-12 font-weight-700 color-181F33 mb-16">Bookings being merged</div>
  <div class="booking-cards displayFlex">
    <div class="single-card displayFlexColumn mr-12" *ngFor="let booking of bookings">
      <div class=" card-row displayFlexSpaceBetween mb-16">
        <div class="fs-14 font-weight-700 displayFlex align-item-flex-start " style="width: 240px;">{{booking.bookingId}} <span
            class="ml-8 " *ngIf="booking.guardReq"> <img src="assets/MarshallGrey.svg" alt=""></span></div>
        <div class="view-details" (click)="openDetailsSidebar(booking)">View Details</div>
      </div>
      <div class="card-row displayFlexSpaceBetween mb-16">
        <div>
          <div class="fs-10 geoaraea-label mb-2">Booking Type</div>
          <div class="color-181F33 fs-12">{{booking.spotBookingType}}</div>
        </div>
        <div class="right-box">
          <div class="fs-10 geoaraea-label mb-2">Start Time</div>
          <div class="color-181F33 fs-12">{{getDateTime(booking.startTime)}}</div>
        </div>
      </div>
      <div class="card-row displayFlexSpaceBetween">
        <div>
          <div class="fs-10 geoaraea-label mb-2">Cab Type</div>
          <div class="color-181F33 fs-12">{{booking.vehicleType}}</div>
        </div>
        <div class="right-box">
          <div class="fs-10 geoaraea-label mb-2">Billing Type</div>
          <div class="color-181F33 fs-12">{{booking.paymentType}}</div>
        </div>
      </div>
    </div>
  </div>

  <div class="form-container mt-32" >
    <ng-container *ngFor="let field of config.elementConfigList">
      <div class="form-control half-width displayFlexColumn mr-16" *ngIf="checkVisibility(field.config, formDetails)">
        <div class="form-label fs-12 font-weight-400  color-181F33" *ngIf="field.elementKey!='guardReq'">{{field.config.displayName}}</div>
        <span class="optional" *ngIf="field.elementKey!='guardReq' && !field.config.mandatory" >(optional)</span>
        <div class="form-input">
          <app-select-sectioned *ngIf="field.config.elementType == 'dropdown'"
            [formControl]="formDetails.get(field.elementKey)" type="dropdown" [getCustomOptionValue]="getOptionValue"
            [getCustomOptionLabel]="getOptionLabel" [options]="options[field.elementKey]">
          </app-select-sectioned>
          <app-field-generator *ngIf="field.config.elementType != 'dropdown' && field.elementKey!='guardReq'"
            [config]="field.config" [inputControl]="formDetails.get(field.elementKey)">
          </app-field-generator>
        </div>
      </div>
    </ng-container>
  </div>
</div>